(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@omim/icon"), require("omi"));
	else if(typeof define === 'function' && define.amd)
		define(["@omim/icon", "omi"], factory);
	else if(typeof exports === 'object')
		exports["MButton"] = factory(require("@omim/icon"), require("omi"));
	else
		root["MButton"] = factory(root["MIcon"], root["Omi"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__icon__, __WEBPACK_EXTERNAL_MODULE_omi__) {
return 